/**
 * @generated SignedSource<<03d0bf85a04cd999b38f3ac5b1ee9545>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateWhatToSeeBlockInput = {
  description?: string | null;
  name: string;
};
export type AddWhatToSeeBlockDialogMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  input: CreateWhatToSeeBlockInput;
};
export type AddWhatToSeeBlockDialogMutation$data = {
  readonly addBlockToWhatToSee: {
    readonly node: {
      readonly description: string | null;
      readonly id: string;
      readonly name: string;
    };
  };
};
export type AddWhatToSeeBlockDialogMutation = {
  response: AddWhatToSeeBlockDialogMutation$data;
  variables: AddWhatToSeeBlockDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "WhatToSeeBlock",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddWhatToSeeBlockDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "WhatToSeeBlockNode",
        "kind": "LinkedField",
        "name": "addBlockToWhatToSee",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddWhatToSeeBlockDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "WhatToSeeBlockNode",
        "kind": "LinkedField",
        "name": "addBlockToWhatToSee",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "WhatToSeeBlockEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e81c5b9e116d97d3a17e99598b53ea1a",
    "id": null,
    "metadata": {},
    "name": "AddWhatToSeeBlockDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AddWhatToSeeBlockDialogMutation(\n  $id: ID!\n  $input: CreateWhatToSeeBlockInput!\n) {\n  addBlockToWhatToSee(id: $id, input: $input) {\n    node {\n      id\n      name\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0cea933a17666f12d5835845bc9ef0cb";

export default node;
